import { CreateRequest } from "@models";
import i18n from "../i18n";
import { requestService } from "@services";
import { message } from "@messages";
import { AxiosError } from "axios";
import { makeAutoObservable, runInAction } from "mobx";

export default class RequestStore {
  customerId = 0;
  responseMessage = {
    text: "",
    description: "",
    status: "",
  };
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  setLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };

  create = async (request: CreateRequest) => {
    this.setLoading(true);
    try {
      const result = await requestService.create(request);
      this.setLoading(false);
      this.setMessage(
        i18n.t(
          request.isAutoBooking
            ? "BookingConfirmedSuccess"
            : "RequestSentSuccess",
        ),
        i18n.t(
          request.isAutoBooking
            ? "BookingConfirmedDescription"
            : "RequestSentDescription",
        ),
        "success",
      );

      if (!result) return null;

      runInAction(() => {
        this.customerId = result.id;
      });

      return result;
    } catch (error) {
      this.setLoading(false);
      if (error instanceof AxiosError) {
        message.error(error.response?.data?.error?.message);
      }
      return null;
    }
  };

  setMessage = (text: string, description: string, status: string) => {
    runInAction(() => {
      this.responseMessage.text = text;
      this.responseMessage.description = description;
      this.responseMessage.status = status;
    });
  };
  resetMessage = () => {
    runInAction(() => {
      this.responseMessage.text = "";
      this.responseMessage.description = "";
      this.responseMessage.status = "";
    });
  };
}
